import { render, staticRenderFns } from "./HistoricOrdinanceDetail.vue?vue&type=template&id=0146730e&"
import script from "./HistoricOrdinanceDetail.vue?vue&type=script&lang=ts&"
export * from "./HistoricOrdinanceDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports